module.exports = __webpack_public_path__ + "595e6f909b79c797adaa84e0207e1e7d.svg";